import React from "react";
import "./ContextMenu.css";

const ContextMenu = ({
  contextMenu,
  showEdit,
  showDelete,
  onView,
  onEdit,
  onDelete,
  onViewLogs,
}) => {
  return (
    <ul
      className="context-menu"
      style={{ top: contextMenu.y, left: contextMenu.x }}
      onClick={(e) => e.stopPropagation()}
    >
      <li className="context-menu-item" onClick={onView}>
        <i className="fas fa-eye context-menu-icon"></i>
        View
      </li>
      {showEdit && (
        <li className="context-menu-item" onClick={onEdit}>
          <i className="fas fa-edit context-menu-icon"></i>
          Edit
        </li>
      )}
      {showDelete && (
        <li className="context-menu-item" onClick={onDelete}>
          <i className="fas fa-trash-alt context-menu-icon"></i>
          Delete
        </li>
      )}
      <li className="context-menu-item" onClick={onViewLogs}>
        <i className="fas fa-history context-menu-icon"></i>
        View Logs
      </li>
    </ul>
  );
};

export default ContextMenu;
